import flightGraph from 'core-lib/components/flightGraph/flightGraph.vue'
import flightPriceDetail from 'core-lib/components/flightPriceDetail/flightPriceDetail.vue'
import totalPayCard from 'core-lib/components/briefSummary/totalPayCard/totalPayCard.vue'
import moment from 'moment'
import axios from 'axios'
import get from 'lodash/get'

export default {
  props: {
    'flightSelected': {
      type: Object,
      required: true,
      default: () => { return {} }
    },
    'currency': String,
    'flightReturnSelected': {
      type: Object,
      required: true,
      default: () => { return {} }
    },
    'showSummary': {},
    'lookingForReturn': {},
    'action': {
      type: Object,
      default: () => { return {} }
    },
    'alwaysShowContinue': {},
    'extraServicesData': {
      type: Object
    },
    'summaryBehavior': {},
    'sendTotals': {
      default: true
    },
    'finalList': {
      type: Array,
      default: () => { return null }
    },
    'finalReturnList': {
      type: Array,
      default: () => { return null }
    },
    'searchShopChoice': {
      default: () => { return null }
    },
    'summaryKey': {
      type: Number,
      default: 0
    }
  },
  components: {
    flightGraph,
    flightPriceDetail,
    totalPayCard
  },
  data() {
    return {
      showingTab: false,
      hidingDeparture_tab: true,
      hidingPrice_tab: true,
      hidingReturn_tab: true,
      hidingConditions_tab: true,
      demoDont: false,
      search: this.$store.state.search,
      configs: {},
      currencySelected: null,
      price: null
    }
  },
  watch: {
    price: function (newPrice) {
      this.$store.commit('setBookingPrices', {
        summaryPrice: newPrice + this.extraServicesPrice
      })
    },
    extraServicesData: function (newExtraServicesData) {
      let extraServicesTotal = get(newExtraServicesData, 'total', 0)
      this.$store.commit('setBookingPrices', {
        summaryPrice: this.summaryPrice + extraServicesTotal
      })
    },
    'summaryBehavior.showSummary': function (summaryOpened) {
      if (summaryOpened) {
        this.$nextTick(() => {
          const termsElement = get(
            document.getElementsByClassName('actionNav__terms'),
            '[0]',
            null
          )
          const tabsContainer = document.getElementsByClassName('briefSummary__tabContainer')
          if (tabsContainer.length && termsElement) {
            const height = termsElement.clientHeight
            for (let index = 0; index < tabsContainer.length; index++) {
              const element = tabsContainer[index]
              element.style.padding = `3.5rem .5rem calc(3.5rem + ${height}px) .5rem`
            }
          }
        })
      }
    }
  },
  methods: {
    getTermConditionsUrl () {
      return `${window.location.pathname}terms` + this.$route.fullPath
    },
    formatDate (date) {
      return moment(date, 'DD/MM/YYYY').locale(this.$i18n.locale).format('DD/MM/YYYY')
    },
    formatDateFlight (date) {
      return moment(date, 'YYYY/MM/DD').locale(this.$i18n.locale).format('DD/MM/YYYY')
    },
    toggleDetails (whichOne) {
      this.closeDetails()
      this.showingTab = true
      this[`${whichOne}`] = false
    },
    closeDetails () {
      this.showingTab = false
      this.hidingPrice_tab = true
      this.hidingDeparture_tab = true
      this.hidingReturn_tab = true
      this.hidingConditions_tab = true
    },
    setPrice() {
      if (!this.flightSelected.fare) return null
      // TODO this.data.summary.total_amount_retrieve_booking
      this.price = 0
      this.price += parseFloat(
        get(
          this.flightSelected.fare.price,
          'average_amount',
          this.flightSelected.fare.price.segment_price
        )
      )
      if (this.flightReturnSelected.flight) {
        this.price += parseFloat(
          get(
            this.flightReturnSelected.fare.price,
            'average_amount',
            this.flightReturnSelected.fare.price.segment_price
          )
        )
      }
      this.currencySelected = this.flightSelected.fare.price.currency_reference_id.split('_')[0]
      return this.price
    },
    toggleSummary () {
      this.closeDetails()
      this.$emit('toggleSummary')
    },
    searchReturn () {
      this.toggleSummary()
      this.$emit('searchReturn')
    },
    submi () {
      this.$emit('submit')
    },
    formatNumberToLocale (importe) {
      return importe.toLocaleString()
    }
  },
  computed: {
    showPrice: function () {
      return (this.search.return_flight && this.flightReturnSelected.price) || (!this.search.return_flight && this.flightSelected.flight)
    },
    areBookingPricesEqual: function () {
      return !this.$store.getters.areBookingPricesDifferent
    },
    summaryPrice: function () {
      return parseFloat(this.areBookingPricesEqual ? this.setPrice() : (this.$store.getters.getBookingPrices.purchasePrice - this.extraServicesPrice))
    },
    extraServicesPrice: function () {
      return parseFloat(get(this.extraServicesData, 'total', 0))
    },
    priceAndExtraServices: function () {
      return parseFloat(this.summaryPrice + this.extraServicesPrice)
    },
    previousTotalSummaryPrice: function () {
      return parseFloat(this.$store.getters.getBookingPrices.summaryPrice)
    },
    haveExtraServices: function () {
      return this.extraServicesData && Object.keys(this.extraServicesData).length > 0
    },
    priceFormatter: function () {
      return price => price.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    strainExtraServices: function () {
      if (this.extraServicesData) {
        const nonServiceList = new Set(this.$store.state.systemStore.generalSetting.ssr_not_services)
        const ancillariesQuotations = this.extraServicesData.ancillaries_quotations.filter(
          ancillarie => !nonServiceList.has(ancillarie.service_reference_id)
        )
        return {
          'ancillaries_quotations': ancillariesQuotations,
          'currency': this.extraServicesData.currency,
          'total': this.extraServicesData.total
        }
      } 
      return {
        'ancillaries_quotations': [],
        'currency': this.currency,
        'total': 0
      }
    },
    getFamilyFareName: function () {
      const flightPrice = get(this.flightSelected, 'price', '')
      const flightCompletePrice = get(this.flightSelected, 'fare.name', flightPrice)
      if (flightCompletePrice) {
        return flightCompletePrice.split('_')[0]
      }
      return ''
    },
    getReturnFamilyFareName: function () {
      const flightPrice = get(this.flightReturnSelected, 'price', '')
      const flightCompletePrice = get(this.flightReturnSelected, 'fare.name', flightPrice)
      if (flightCompletePrice) {
        return flightCompletePrice.split('_')[0]
      }
      return ''
    }
  }
}
